import React from "react";

import "../minhas-chaves/Style.css";
import { Link, useNavigate } from "react-router-dom";

import { useEffect } from "react";
import { deleteKey, deleteKeyFiducia, getAll } from "../../../../services/pix.service";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { css } from "@emotion/react";
import BeatLoader from "react-spinners/BeatLoader";
import "react-toastify/dist/ReactToastify.css";
import "react-toastify/dist/ReactToastify.min.css";
import { MdKeyboardArrowRight, MdAdd } from "react-icons/md";
import PixKeyCard from "../pix-key-card/PixKeyCard";
import ReactModal from "react-modal";
import CadastrarChaveModal from "../cadastrar-chave-modal/CadastrarChaveModal";
import { TbKey } from "react-icons/tb";
import { useAuth } from "../../../../hooks/useAuth";
import { getFiduciaToken } from "../../../../utils/sessionMethods";

export default function () {
  const [rows, setRows] = useState();
  const [loader, setLoader] = useState(false);
  const [transationalPassword, setTransationalPassword] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [isFiduciaAccount, setIsFiduciaAccount] = useState(false);
  const [deleteKeyId, setDeleteKeyId] = useState();

  const [createPixKeyModal, setCreatePixKeyModal] = useState(false);
  const [ isWaitDBChange, setIsWaitDBChange] = useState(false);

  const { account } = useAuth()

  const navigate = useNavigate();
  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    margin-top: 3em;
  `;

const confirm = () => {
  const bank = account.bank

  if( bank != "450"){
      setIsFiduciaAccount(true)
  }else{
    setMostrarModal(false)
      deleteKey(deleteKeyId, navigate).then(isDeleted => {
        if(isDeleted){
          getKeys();
        }
      })
  }
}

const close = () => {
  setMostrarModal(false);
  setTransationalPassword('');
}

const deletepixKeyFiducia = () => {
  if (!transationalPassword && bank !== "450") {
      toast.error("Digite a senha");
      return;
  }

  const token = getFiduciaToken()

  setMostrarModal(false)
  deleteKeyFiducia(deleteKeyId, navigate, transationalPassword, token).then(isDeleted => {
    if(isDeleted){
      getKeys();
    }
  })
}

const deleteKeyModal = async (id) => {
  setMostrarModal(true);
  setDeleteKeyId(id);
}

  const getKeys = async () => {
    if (localStorage.getItem("taxNumber") == "12345678900") {
      setRows([
        {
          id: 259,
          personId: 332,
          type: "4",
          key: "ae42d3d8-b36c-4a8e-awc9-d89f6d43fb9e",
          status: "0",
          createdAt: "2023-09-26 13:47:00",
          updatedAt: "2023-09-26 13:47:00",
        },
        {
          id: 224,
          personId: 332,
          type: "2",
          key: "teste@teste.com.br",
          status: "0",
          createdAt: "2023-08-01 13:30:00",
          updatedAt: "2023-08-09 13:13:48",
        },
      ]);
      return;
    }

    setLoader(true);
    try {
      const response = await getAll();
      setRows(response);
    } catch (error) {
      toast.error("Erro ao recuperar as chaves, tente novamente");
    }
    setLoader(false);
  };

  useEffect(() => {
    getKeys();
    if(isWaitDBChange){
      setIsWaitDBChange(false);
    }
  }, [isWaitDBChange]);

  const closeModal = (value) => {
    //setModalIsOpen(false);
  }

  return (
    <div className="minhas-chaves-pix">
      <div className="minhas-chaves-pix-container col-md-10">
        <div className="header">
          <div className="col-xl-12">
            <label>
              <Link to={"/pagina-principal"}>
                Pagina inicial
                <MdKeyboardArrowRight size={20} />
              </Link>
              <Link to={"/pagina-pix"}>
                Área Pix
                <MdKeyboardArrowRight size={20} />
              </Link>
              Minha Chaves
            </label>
            <p>Minha Chaves</p>
          </div>
        </div>

        <div className="body">

          <div className="chave-cadastrada col-md-10">
            <p>Gerencie suas chaves</p>
              <button onClick={()=>{setCreatePixKeyModal(true)}}>
                <MdAdd size={20}/>
                Cadastrar Chave
              </button>
          </div>

          <div className="key-list">
            {rows ? (
              <>
                {rows.map((item) => (
                  <PixKeyCard
                    key={item.id}
                    chave={item.key}
                    tipo={item.type}
                    id={item.id}
                    editavel={ item.status == 2 ? false : true}
                    deleteKey={deleteKeyModal}
                  />
                ))}
              </>
            ) : (
              <BeatLoader color={"var(--secondary-color)"} loading={loader} css={override} size={20} />
              )}
          </div>
        </div>
      </div>
      <ToastContainer limit={2} />
      <ReactModal isOpen={mostrarModal} className={'password-modal'} overlayClassName={'overlay-password-modal'}>
                <div className="password-modal-container col-md-10">
                  <h1>Deseja realmente deletar essa chave?</h1>
                  {!isFiduciaAccount ?
                  <>
                      <div className="button-area">
                          <button className="cancel-button" onClick={close}>Não</button>
                          <button className="confirm-button" onClick={()=>confirm()}>Sim</button>
                      </div>
                  </>
                  :
                  <>
                      <label>Senha</label>
                      <div className="input-area">
                      <div className="col-md-1 input-area-icon">
                        <TbKey size={20} color="#000" />
                      </div>
                        <input type={'password'} value={transationalPassword} onChange={(e)=>setTransationalPassword(e.target.value)}/>

                      </div>
                      <div className="button-area">
                          <button className="cancel-button" onClick={close}>Não</button>
                          <button className="confirm-button" onClick={()=>deletepixKeyFiducia()}>Sim</button>
                      </div>
                  </>
                  }
                </div>
      </ReactModal>

      <CadastrarChaveModal
        createPixKeyModal={createPixKeyModal}
        setCreatePixKeyModal={setCreatePixKeyModal}
        setIsWaitDBChange={setIsWaitDBChange}
        refreshList={getKeys}
        onRequestClose={() => closeModal()}
      />
    </div>
  );
}
